import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import classes from './styles/listSidebarHeader.module.scss';
import { ThemeStyle } from '../../../../utils/const';
import { useStyleContextState } from '../../../../../ReactSharedScripts/modules/styleContext';

export const ListSidebarHeader: FC<PropsWithChildren> = ({ children }) => {
	const { theme } = useStyleContextState();
	const componentClasses = classNames(classes.listSidebarHeader, {
		[classes.listSidebarHeader_lightTheme]: theme === ThemeStyle.Light,
		[classes.listSidebarHeader_grayTheme]: theme === ThemeStyle.Dark,
	});

	return <section className={componentClasses}>{children}</section>;
};
